import CREDatosSucursal from './CREDatosSucursal'
import { useDispatch, useSelector } from 'react-redux'
import { comprobanteRetencionFisicoClear, comprobanteRetencionFisicoOpenModal, comprobanteRetencionModalSetUser, comprobanteRetencionOpenModalDocumentos } from '../../../../actions/comprobante-retencion/comprobanteRetencionProductos.actions'
import { State } from '../../../../reducers'

const CREDatosProducto = () => {
  const formCliente = useSelector((state:State) => state.comprobanteRetencion.formCliente)
  const dispatch = useDispatch();
  
  const buscarDocumento = () => {
    dispatch(comprobanteRetencionOpenModalDocumentos())
    dispatch(comprobanteRetencionModalSetUser({tipoDoc: formCliente.tipoDocumento, numId: formCliente.numId}))
  }

  const agregarDocFisico = () => {
    dispatch(comprobanteRetencionFisicoOpenModal(true))
    dispatch(comprobanteRetencionFisicoClear())
  }

  return (<div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        <CREDatosSucursal/>
        <h3 className='card-title l'>Asociar documentos</h3>
        <div className='form-separator'></div>
        <div style={{display: 'flex', width: '100%', marginTop:"7%", justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: '30px'}}>
          <button type='button' onClick={buscarDocumento} style={{display: 'flex', width: '50%', borderRadius: '40px'}} className="button">Buscar documentos</button>
          <button type='button' onClick={agregarDocFisico} style={{display: 'flex', width: '50%', borderRadius: '40px'}} className="button">Agregar documentos físico</button>
        </div>
      </div>
    </div>)
}

export default CREDatosProducto
